import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2, Circle, X, ArrowRight } from "lucide-react";

export function WelcomeChecklist() {
  const [data, setData] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    let cancelled = false;
    api.get("/onboarding/checklist").then((r) => { if (!cancelled) setData((prev) => (prev?.dismissed ? prev : r.data)); }).catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (!data || data.dismissed || data.completed === data.steps.length) return null;
  const dismiss = async () => {
    setData({ ...data, dismissed: true });
    try { await api.post("/onboarding/checklist/dismiss"); } catch { setData({ ...data, dismissed: false }); }
  };
  const next = data.steps.find((s) => !s.done);

  return (
    <div className="bg-white rounded-xl border border-emerald-200 shadow-sm p-6" data-testid="welcome-checklist">
      <div className="flex items-start justify-between gap-4 mb-4">
        <div>
          <h2 className="font-display font-bold text-lg text-slate-900">Welcome to ConsignOut</h2>
          <p className="text-sm text-slate-500" data-testid="welcome-checklist-progress">{data.completed} of {data.steps.length} done. Finish these to close your first month.</p>
        </div>
        <button data-testid="welcome-checklist-dismiss" onClick={dismiss} aria-label="Dismiss" className="p-1.5 rounded-lg text-slate-400 hover:bg-slate-100 hover:text-slate-700"><X className="w-4 h-4" /></button>
      </div>
      <div className="h-1.5 bg-slate-100 rounded-full mb-4 overflow-hidden"><div className="h-full bg-emerald-500 transition-[width] duration-500" style={{ width: `${(data.completed / data.steps.length) * 100}%` }} /></div>
      <ol className="space-y-2">
        {data.steps.map((s, idx) => (
          <li key={s.key}>
            <button data-testid={`welcome-step-${s.key}`} onClick={() => navigate(s.link)}
              className={`w-full flex items-center gap-3 text-left rounded-lg px-3 py-2.5 transition-colors ${s === next ? "bg-emerald-50 hover:bg-emerald-100" : "hover:bg-slate-50"}`}>
              {s.done ? <CheckCircle2 className="w-5 h-5 text-emerald-600 shrink-0" data-testid={`welcome-step-${s.key}-done`} /> : <Circle className="w-5 h-5 text-slate-300 shrink-0" />}
              <span className="flex-1 min-w-0">
                <span className={`block text-sm font-semibold ${s.done ? "text-slate-400 line-through" : "text-slate-800"}`}>{idx + 1}. {s.title}</span>
                {!s.done && <span className="block text-xs text-slate-500">{s.hint}</span>}
              </span>
              {s === next && <ArrowRight className="w-4 h-4 text-emerald-700 shrink-0" />}
            </button>
          </li>
        ))}
      </ol>
    </div>
  );
}
